export const SW_UPDATE_STATUS_EVENT = 'sw-update-status';
export const APP_UPDATE_AVAILABLE_EVENT = 'app-update-available';

export type SwUpdateStatus = 'idle' | 'updating';

export function emitSwUpdateStatus(status: SwUpdateStatus) {
  try {
    window.dispatchEvent(new CustomEvent(SW_UPDATE_STATUS_EVENT, { detail: { status } }));
  } catch {
    // No interrumpir el flujo si el navegador no soporta CustomEvent.
  }
}

export function emitAppUpdateAvailable(detail: { current: string; remote: string; source: string }) {
  try {
    window.dispatchEvent(new CustomEvent(APP_UPDATE_AVAILABLE_EVENT, { detail }));
  } catch {
    // noop
  }
}
